import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User, UserString } from '@/types';

export interface ProfileResponse {
  id: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  address: string;
  mobile: string;
  fixe: string;
  enabled: boolean;
  emailVerified: boolean;
  createdTimestamp: number;
  acs: any[];
  coms: any[];
  roles: string[];
}

export interface ProfileUpdateRequest {
  email: string;
  firstName: string;
  lastName: string;
  address: string;
  mobile: string;
  fixe: string;
}

export interface PasswordResetRequest {
  newPassword: string;
  confirmPassword: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private http = inject(HttpClient);
  private baseUrl = environment.api.authUrl;

  getProfile(): Observable<ProfileResponse> {
    return this.http.get<ProfileResponse>(`${this.baseUrl}/keycloak/profile`);
  }

  updateProfile(profile: ProfileUpdateRequest): Observable<ProfileResponse> {
    return this.http.put<ProfileResponse>(`${this.baseUrl}/keycloak/profile`, profile);
  }

  getUserList(): Observable<User[]> {
    return this.http.get<User[]>(`${this.baseUrl}/keycloak/users`);
  }
  getProfileUsers(): Observable<UserString[]> {
    return this.http.get<UserString[]>(`${this.baseUrl}/keycloak/users`);
  }

  resetPassword(payload: PasswordResetRequest): Observable<any> {
    return this.http.put(`${this.baseUrl}/keycloak/profile/password`, payload);
  }

  getUserComs(): Observable<any[]> {
    return this.getProfile().pipe(map(profile => profile.coms));
  }

  getUsersNotInCom(comId: number): Observable<User[]> {
    return this.http.get<User[]>(`${this.baseUrl}/keycloak/users/com?comId=${comId}`);
  }
}
